import React from 'react';
import classes from './TypeFilter.module.scss';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { isPorscheArchiv } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

const typeFilter = (props) => {
    if(props.hidden) return "";
    
    props.setCustomCurrentMainFilter(props.filter);
    return (
        <div className={classes.typeFilter}>
            <span>{props.typeFilterLabel}</span>
            <div onClick={() => props.toogleFilter('pictures')}>
                <FontAwesomeIcon className={props.filter.indexOf('pictures') > -1 ? classes.filterEnabled : classes.filterDisabled} icon="image" />
            </div>
            <div onClick={() => props.toogleFilter('video')}>
                <FontAwesomeIcon className={props.filter.indexOf('video') > -1 ? classes.filterEnabled : classes.filterDisabled} icon="video" />
            </div>
            <div onClick={() => props.toogleFilter('other')}>
                <FontAwesomeIcon className={props.filter.indexOf('other') > -1 ? classes.filterEnabled : classes.filterDisabled} icon="file" />
            </div>
            <div onClick={() => props.toogleFilter('audio')}>
                <FontAwesomeIcon className={props.filter.indexOf('audio') > -1 ? classes.filterEnabled : classes.filterDisabled} icon="music" />
            </div>
            { isPorscheArchiv() ?
                <div onClick={() => props.toogleFilter('empty')}>
                    <FontAwesomeIcon className={props.filter.indexOf('empty') > -1 ? classes.filterEnabled : classes.filterDisabled} icon={faTimes} />
                </div> : ""
            }
        </div>
    )

}

//export default typeFilter;

const mapStateToProps = (state) => ({
    customCurrentMainFilter: state.customData.customCurrentMainFilter

});
const mapDispatchToProps = (dispatch) => {
    return {
        setCustomCurrentMainFilter: (option) => dispatch(actions.setCustomCurrentMainFilter(option)),
        setCliplistFilter: (filter) => dispatch(actions.setCliplistFilter(filter)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(typeFilter);
